import { createReducer, on } from '@ngrx/store';
import {
  loadCaptures,
  loadCapturesSuccess,
  loadCapturesFailure,
  addCapture,
  addCaptureSuccess,
  addCaptureFailure,
  clearCaptures,
} from './captures.actions';
import { CapturesState } from '../../interfaces/state/reducers/captures-state.interface';

const initialState: CapturesState = {
  captures: [],
  currentSessionId: null,
  loading: false,
  error: null,
};

export const capturesReducer = createReducer(
  initialState,
  on(loadCaptures, (state, { sessionId }) => ({ ...state, currentSessionId: sessionId, loading: true, error: null })),
  on(loadCapturesSuccess, (state, { captures }) => ({
    ...state,
    captures,
    loading: false,
  })),
  on(loadCapturesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  // Uploads run in the background, so they must not raise the global loading overlay.
  on(addCapture, (state) => ({ ...state, error: null })),
  // The upload may finish after the user has moved to another session; only merge into the session on screen.
  on(addCaptureSuccess, (state, { capture }) =>
    capture.sessionId !== state.currentSessionId
      ? state
      : {
          ...state,
          captures: state.captures.some((c) => c.id === capture.id)
            ? state.captures.map((c) => (c.id === capture.id ? capture : c))
            : [...state.captures, capture],
        }
  ),
  // The failure may belong to a session that is no longer on screen; the toast reports it, so don't set the page error.
  on(addCaptureFailure, (state) => ({ ...state, error: null })),
  on(clearCaptures, () => initialState)
);
